module.exports = __webpack_public_path__ + "img/icon-price.86bac56f.svg";